import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { HorizonTargetPicker } from './HorizonTargetPicker';
import { HorizonReviewerPicker } from './HorizonReviewerPicker';
import { HorizonWorkloadPicker } from './HorizonWorkloadPicker';
import { HorizonScopeSummary } from './HorizonScopeSummary';
import { HorizonTargetIntents } from './HorizonTargetIntents';

export const horizonTargetIntentsExtension = FormFieldBlueprint.make({
  name: 'horizon-target-intents',
  params: {
    field: async () =>
      createFormField({
        name: 'HorizonTargetIntents',
        component: HorizonTargetIntents,
        schema: makeFieldSchema({
          output: z =>
            z.record(
              z.string(),
              z.object({
                schemaVersion: z.literal('assess-target-intent/1'),
                requestedAmiId: z.string().nullable(),
                desiredOs: z
                  .object({
                    family: z.enum(['linux', 'windows']),
                    distribution: z.string().nullable(),
                    version: z.string().nullable(),
                  })
                  .nullable(),
                destinationRequest: z
                  .object({
                    provider: z.enum(['aws', 'azure', 'gcp', 'other']),
                    providerName: z.string().nullable().optional(),
                    networkId: z.string().nullable().optional(),
                    connectionId: z.string().nullable().optional(),
                    accountId: z.string().nullable().optional(),
                    region: z.string().nullable().optional(),
                    vpcId: z.string().nullable().optional(),
                    subnetId: z.string().nullable().optional(),
                    securityGroupIds: z.array(z.string()).nullable().optional(),
                    instanceType: z.string().nullable().optional(),
                    testSubnetId: z.string().nullable().optional(),
                    testSecurityGroupIds: z
                      .array(z.string())
                      .nullable()
                      .optional(),
                    kmsKeyArn: z.string().nullable().optional(),
                    launchTemplateId: z.string().nullable().optional(),
                    launchTemplateVersion: z.number().nullable().optional(),
                    testLaunchTemplateVersion: z.number().nullable().optional(),
                    replicationConfigurationRef: z
                      .string()
                      .nullable()
                      .optional(),
                    storageConfigurationRef: z.string().nullable().optional(),
                    iamInstanceProfileArn: z.string().nullable().optional(),
                    rootVolumeGiB: z.number().nullable().optional(),
                  })
                  .nullable()
                  .optional(),
                destination: z
                  .object({
                    connectionId: z.string(),
                    accountId: z.string(),
                    region: z.string(),
                    vpcId: z.string(),
                    subnetId: z.string(),
                    securityGroupIds: z.array(z.string()),
                    landingZoneVersion: z.string(),
                    instanceType: z.string(),
                    testSubnetId: z.string().optional(),
                    testSecurityGroupIds: z.array(z.string()).optional(),
                    kmsKeyArn: z.string().optional(),
                    launchTemplateId: z.string().optional(),
                    launchTemplateVersion: z.number().optional(),
                    testLaunchTemplateVersion: z.number().optional(),
                    replicationConfigurationRef: z.string().optional(),
                    storageConfigurationRef: z.string().optional(),
                    iamInstanceProfileArn: z.string().optional(),
                    rootVolumeGiB: z.number().optional(),
                  })
                  .nullable(),
              }),
            ),
        }),
      }),
  },
});

export const horizonScopeSummaryExtension = FormFieldBlueprint.make({
  name: 'horizon-scope-summary',
  params: {
    field: async () =>
      createFormField({
        name: 'HorizonScopeSummary',
        component: HorizonScopeSummary,
        schema: makeFieldSchema({ output: z => z.string() }),
      }),
  },
});

const horizonWorkloadPickerSchema = makeFieldSchema({
  output: z => z.string(),
});
const horizonTargetPickerSchema = makeFieldSchema({
  output: z => z.string(),
});
const horizonReviewerPickerSchema = makeFieldSchema({
  output: z => z.string(),
});

const horizonWorkloadPickerField = createFormField({
  name: 'HorizonWorkloadPicker',
  component: HorizonWorkloadPicker,
  schema: horizonWorkloadPickerSchema,
});
const horizonTargetPickerField = createFormField({
  name: 'HorizonTargetPicker',
  component: HorizonTargetPicker,
  schema: horizonTargetPickerSchema,
});
const horizonReviewerPickerField = createFormField({
  name: 'HorizonReviewerPicker',
  component: HorizonReviewerPicker,
  schema: horizonReviewerPickerSchema,
});

export const horizonWorkloadPickerExtension = FormFieldBlueprint.make({
  name: 'horizon-workload-picker',
  params: {
    field: async () => horizonWorkloadPickerField,
  },
});

export const horizonTargetPickerExtension = FormFieldBlueprint.make({
  name: 'horizon-target-picker',
  params: {
    field: async () => horizonTargetPickerField,
  },
});

export const horizonReviewerPickerExtension = FormFieldBlueprint.make({
  name: 'horizon-reviewer-picker',
  params: {
    field: async () => horizonReviewerPickerField,
  },
});
